// React (tarayıcı) tarafı Supabase client fabrikası.
// Yalnızca ANON key kullanır — service_role buraya ASLA girmez.
// RLS tüm iş tablolarını korur; bu client sadece auth ve okuma işlemleri için.

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

type Result =
  | { ok: true; client: SupabaseClient }
  | { ok: false; error: { code: "not_configured"; missing: string[] } };

/**
 * Tarayıcıda tek bir Supabase client örneği.
 * CRA env değişkenleri REACT_APP_ ile başlar; build sırasına gömülür.
 */
let cached: SupabaseClient | null = null;

export function createBrowserSupabase(): Result {
  const url = process.env.REACT_APP_SUPABASE_URL;
  const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

  const missing: string[] = [];
  if (!url) missing.push("REACT_APP_SUPABASE_URL");
  if (!anon) missing.push("REACT_APP_SUPABASE_ANON_KEY");

  if (missing.length) {
    return { ok: false, error: { code: "not_configured", missing } };
  }

  if (!cached) {
    cached = createClient(url as string, anon as string, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  }
  return { ok: true, client: cached };
}

/**
 * Oturum açmış kullanıcının JWT'sini alıp Pages Function'a iletir.
 * API çağrılarında Authorization header kurmak için.
 */
export async function getAccessToken(): Promise<string | null> {
  const factory = createBrowserSupabase();
  if (!factory.ok) return null;
  const { data } = await factory.client.auth.getSession();
  return data.session?.access_token ?? null;
}
